import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Divider, Typography } from '@material-ui/core';
import { colors } from 'theme';
import { DialogWidth, SortingCenter } from 'types';
import ClosureErrorIcon from '../../Icons/ClosureErrorIcon';
import ClosureWarningIcon from '../../Icons/ClosureWarningIcon';
import Dialog from '../../Dialog';

const useStyles = makeStyles(theme => ({
  icon: {
    color: colors.primary,
    fontSize: '5em',
  },
  closeIcon: {
    width: '1em',
  },
  closeButton: {
    marginTop: '30px',
  },
  errorItem: {
    '& span': {
      color: colors.primary,
    },
  },
  warning: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 15,
  },
  warningIcon: {
    color: colors.darkOrange,
    fontWeight: 'bold',
    width: '5em',
    margin: '0',
  },
  warningText: {
    fontSize: '18px',
    margin: 'auto 0',
    marginLeft: '20px',
    textAlign: 'left',
    fontWeight: 600,
  },
  warningContainer: {
    width: '80%',
    paddingBottom: '15px',
  },
  warningListError: {
    paddingTop: '20px',
    paddingBottom: '20px',

    '& ul': {
      margin: 'auto 0',
      paddingLeft: '25px',

      '& li': {
        textAlign: 'left',
      },
      '& p > span': {
        color: colors.primary,
      },
    },
  },
  tableDivider: {
    width: '100%',
    height: 2,
    marginTop: 'auto',
    marginBottom: 'auto',
    borderBottom: 'none',
    color: colors.greyBlue,
  },
}));

interface Props {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
  handleCancel?: () => void;
  listSortingCenterOnError: (SortingCenter | undefined)[] | undefined;
}

export const DialogErrorSomeUserRoleNotSelected: React.FC<Props> = ({
  isOpen,
  setOpen,
  handleCancel,
  listSortingCenterOnError,
}) => {
  const classes = useStyles();
  const { t } = useTranslation('translation', { keyPrefix: 'administration.users.create' });

  return (
    <Dialog
      closable={false}
      renderButton={() => {}}
      isOpen={isOpen}
      width={DialogWidth.LARGE_FORM}
      title={
        <div className={classes.warning}>
          <ClosureWarningIcon className={classes.warningIcon} />
          <Typography className={classes.warningText}>{t('errorDialog.title')}</Typography>
        </div>
      }
      renderContent={() => (
        <Box className={classes.warningContainer}>
          <Divider className={classes.tableDivider} />
          <Box className={classes.warningListError}>
            <ul>
              {isOpen &&
                listSortingCenterOnError
                  ?.sort((a: SortingCenter | undefined, b: SortingCenter | undefined): number => {
                    if (!a || !b) return 0;
                    if (a.code < b.code) return -1;
                    if (a.code > b.code) return 1;
                    return 0;
                  })
                  .map((sortingCenterError: SortingCenter | undefined, index: number) => {
                    return (
                      sortingCenterError && (
                        <li key={index}>
                          <Typography key={index}>
                            {sortingCenterError.name} - <span>{sortingCenterError.code}</span>
                          </Typography>
                        </li>
                      )
                    );
                  })}
            </ul>
          </Box>
          <Divider className={classes.tableDivider} />
          <Button
            className={classes.closeButton}
            variant="outlined"
            startIcon={<ClosureErrorIcon className={classes.closeIcon} />}
            onClick={handleCancel}
          >
            {t('errorDialog.cancel')}
          </Button>
        </Box>
      )}
    />
  );
};
